import "./styles.scss";
import classNames from "classnames";
import { ReactSVG } from "react-svg";

interface StepsProps {
  title?: string;
  subtitle?: string;
  alt?: string;
  iconLeft?: boolean;
  stepsSubtitle?: string;
  stepsArray: {
    icon?: string;
    title?: string;
    text?: string;
  }[];
  columnsNumber: number;
  styleCard?: boolean;
}

const Steps = ({
  title,
  subtitle,
  stepsArray,
  stepsSubtitle,
  columnsNumber,
  styleCard,
  alt,
  iconLeft,
}: StepsProps) => {
  const classnames = classNames(`Steps`, {
    "Steps--styleCard": styleCard,
    "Steps--iconLeft": iconLeft,
    [`Steps--${alt}`]: alt,
  });

  return (
    <div className={classnames}>
      {title && <h2 className="Steps__mainTitle">{title}</h2>}
      {subtitle && <p className="Steps__mainSubtitle">{subtitle}</p>}
      {stepsSubtitle && <p className="Steps__Subtitle">{stepsSubtitle}</p>}
      <div className={`Steps__list Steps__list--${columnsNumber}-columns`}>
        {stepsArray.map((item, index) => (
          <div
            className="Steps__item"
            key={`Step-item-${index}`}>
            {item.icon ? (
              <ReactSVG
                src={item.icon}
                className="Steps__icon"
                title={item.title}
              />
            ) : (
              <div className="Steps__header">
                <div className="Steps__number">{stepsArray.indexOf(item) + 1}</div>
                {item.title && <div className="Steps__title">{item.title}</div>}
              </div>
            )}
            <>
              {item.text && (
                <span
                  className="Steps__text"
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              )}
            </>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Steps;
